import React from 'react';

interface Props {
  size?: number;
  otherProps?: React.SVGProps<SVGSVGElement>;
}

const PlayStoreIcon: React.FC<Props> = ({ size }) => {
  return (
    <svg
      width={size ?? 18}
      height={size ? size + 1 : 19}
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M10.297 9.716l-9.079 8.743a1.545 1.545 0 01-.673-1.29V2.263A1.545 1.545 0 011.218.973l9.08 8.743z"
        fill="#2196F3"
      />
      <path
        d="M13.474 6.662l-3.177 3.054L1.217.973A1.553 1.553 0 012.893.874l10.582 5.788z"
        fill="#4CAF50"
      />
      <path
        d="M17.325 9.716a1.57 1.57 0 01-.821 1.396l-3.03 1.658-3.176-3.054 3.177-3.054 3.029 1.658c.51.278.827.815.82 1.396z"
        fill="#FFC107"
      />
      <path
        d="M13.474 12.77L2.892 18.557a1.574 1.574 0 01-1.568-.024 1.213 1.213 0 01-.106-.074l9.08-8.743 3.176 3.054z"
        fill="#F44336"
      />
    </svg>
  );
};

export default PlayStoreIcon;
